import { render } from "./OptionFour.vue?vue&type=template&id=7b594028&scoped=true"
import script from "./OptionFour.vue?vue&type=script&lang=js"
export * from "./OptionFour.vue?vue&type=script&lang=js"

import "./OptionFour.vue?vue&type=style&index=0&id=7b594028&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b594028"]])

export default __exports__